var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"facebook-login-button",rawName:"v-facebook-login-button",value:(_vm.appId),expression:"appId"}],staticClass:"mb-5",attrs:{"block":"","loading":_vm.loading},on:{"click":function($event){_vm.loading=true}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-facebook")]),_vm._v(" Sign in with Facebook ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }